if(!customElements.get('contact-form-modal')){
    customElements.define('contact-form-modal', class ContactFormModal extends HTMLElement {
        constructor(){
            super();
            this.openButton = this.querySelector('[data-modal-open]');
            this.closeButton = this.querySelector('[data-modal-close]');
            this.modal = this.querySelector('dialog');
            this.modalContent = this.modal.querySelector('[data-modal-content]')
            this.modalEmbed = this.modalContent.querySelector('.pxFormGenerator');
            
            this.openButton.addEventListener('click', this.handleButtonClick.bind(this))
            this.closeButton.addEventListener('click', this.handleCloseButtonClick.bind(this))
        }
        handleButtonClick(e){
            e.preventDefault();
            if(this.modalEmbed == null){
                //get corresponding 
                let otherModal = document.querySelector(`#${this.modal.id.replace('-desktop', '-mobile')}`);
                this.modalContent.innerHTML = otherModal.querySelector('[data-modal-content]').innerHTML;
                this.modalEmbed = this.modal.querySelector('.pxFormGenerator');
            }
            let iframe = this.modal.querySelector('iframe');
            iframe.style.height = '100%';
            this.modal.addEventListener('click', this.handleModalClick.bind(this));
            this.modal.showModal();
        }
        handleModalClick(event){
            let modalRect = this.modal.getBoundingClientRect();
            let isInModal = (modalRect.top <= event.clientY && event.clientY <= modalRect.top + modalRect.height
            && modalRect.left <= event.clientX && event.clientX <= modalRect.left + modalRect.width);
            console.log(isInModal)
            if (!isInModal) {
                this.modal.close();
            }
        }
        handleCloseButtonClick(e){
            e.preventDefault();
            this.modal.close();
        }
    })
}